module.exports = __webpack_public_path__ + "img/_icon_info_blue.2d297a67.svg";